/**
 * Generate FAQPage JSON-LD schema from FAQ items
 *
 * @param {Array} faqItems - Array of FAQ objects with question and answer properties
 * @returns {Object} JSON-LD FAQPage schema
 */
export const generateFAQSchema = (faqItems) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
};

/**
 * Generate BreadcrumbList JSON-LD schema
 *
 * @param {Array} items - Array of breadcrumb strings
 * @param {string} basePath - Base URL path
 * @param {string} baseUrl - Site base URL
 * @returns {Object} JSON-LD BreadcrumbList schema
 */
export const generateBreadcrumbSchema = (items, basePath, baseUrl) => {
  const pathMap = {
    'Docs': '/docs',
    'Getting Started': '/docs',
    'Core Concepts': '/docs',
    'Technical': '/docs',
    'Models & Scoring': '/docs/models',
    'Resources': '/docs/faq',
    'Overview': '/docs',
    'How It Works': '/docs/how-it-works',
    'Leaderboard': '/docs/leaderboard',
    'LLM Integration': '/docs/llm-integration',
    'Decision Process': '/docs/decision-process',
    'Position Management': '/docs/position-management',
    'Supported Models': '/docs/models',
    'Text vs Vision': '/docs/text-vs-vision',
    'Scoring': '/docs/scoring',
    'FAQ': '/docs/faq',
    'Changelog': '/docs/changelog',
    'API Reference': '/docs/api',
  };

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item,
      item: `${baseUrl}${pathMap[item] || basePath}`,
    })),
  };
};

/**
 * Generate Article JSON-LD schema for documentation pages
 *
 * @param {Object} params - Article parameters
 * @returns {Object} JSON-LD Article schema
 */
export const generateArticleSchema = ({ title, description, url, datePublished, dateModified }) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'TechArticle',
    headline: title,
    description: description,
    url: url,
    datePublished: datePublished || '2024-01-01',
    dateModified: dateModified || new Date().toISOString().split('T')[0],
    author: {
      '@type': 'Organization',
      name: 'DayTradingBench',
    },
    publisher: {
      '@type': 'Organization',
      name: 'DayTradingBench',
      url: 'https://daytradingbench.com',
    },
  };
};
